import axios from "axios";
import { buildApiUrl, encodePathValue, headersRequest } from "../helpers";

export const getStatusCatalog = () => {
  const requestUrl = buildApiUrl("project-status-catalog");
  return axios.get(requestUrl, headersRequest(requestUrl));
};

export const updateProjectStatus = (uid, idEstado) => {
  const requestUrl = buildApiUrl(`projects/${encodePathValue(uid)}/status`);
  return axios.put(requestUrl, { idEstado }, headersRequest(requestUrl));
};
